import { render, staticRenderFns } from "./Package_Add_Product.vue?vue&type=template&id=45d39e64&scoped=true&"
import script from "./Package_Add_Product.vue?vue&type=script&lang=js&"
export * from "./Package_Add_Product.vue?vue&type=script&lang=js&"
import style0 from "./Package_Add_Product.vue?vue&type=style&index=0&id=45d39e64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d39e64",
  null
  
)

export default component.exports